module.exports = __webpack_public_path__ + "img/13.47d06bff.jpg";